import React from 'react';
import { TableCell, TableRow, Grid } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles';

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: 'rgb(117,117,117,1)',
    color: theme.palette.common.black,
    padding: '10px'
  },
  body: {
    fontSize: 14,
    padding: '10px'
  }
}))(TableCell);

const MobileTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: 'rgb(117,117,117,1)',
    color: theme.palette.common.black,
    padding: '5px'
  },
  body: {
    fontSize: 14,
    padding: '5px'
  }
}))(TableCell);

const MobileHeaders = () => {
  return (
    <TableRow >
      <MobileTableCell>
        <Grid item xs={12}>Flight Number</Grid>
        <Grid item xs={12}>Tail Number</Grid>
      </MobileTableCell>
      <MobileTableCell>Summary</MobileTableCell>
      <MobileTableCell>
        <Grid item xs={12}>Departure</Grid>
        <Grid item xs={12}>Arrival</Grid>
      </MobileTableCell>
      <MobileTableCell>Actions</MobileTableCell>
      <MobileTableCell align="center">Pax</MobileTableCell>
    </TableRow>
  )
}

const RegularHeaders = () => {
  return (
    <TableRow >
      <StyledTableCell>Pax</StyledTableCell>
      <StyledTableCell>Actions</StyledTableCell>
      <StyledTableCell>
        <Grid item xs={12}>Flight Number</Grid>
        <Grid item xs={12}>Tail Number</Grid>
      </StyledTableCell>
      <StyledTableCell>Summary</StyledTableCell>
      <StyledTableCell>Departure</StyledTableCell>
      <StyledTableCell>Local Dep Time</StyledTableCell>
      <StyledTableCell>Arrival</StyledTableCell>
      <StyledTableCell>Local Arr Time</StyledTableCell>
    </TableRow>
  )
}

export const RowHeaders = (props) => {
  const isMobile = props.isMobile

  if (isMobile) {
    return <MobileHeaders/>
  }
  else {
    return <RegularHeaders/>
  }
}